import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";


const RegistrationList = () => {
  const [registrations, setRegistrations] = useState([]);
  const [publicForms, setPublicForms] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10; // Number of rows per page
  const listInnerRef = useRef();
  const [usedCount, setUsedCount] = useState(0);
  const [unusedCount, setUnusedCount] = useState(0);
  const [pageInput, setPageInput] = useState("");

  const apiUrl = 'https://api.infosware-test.in';

  // Fetch registrations and public forms on component mount
  useEffect(() => {
    getRegistrations();
    getPublicForms();
  }, []);

  const getRegistrations = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/registrations`);
      const usedRegistrations = response.data.filter(item => item.status === "used");
      setRegistrations(usedRegistrations);
      console.log("Fetched registrations:", usedRegistrations); // Debugging statement
      calculateCounts(response.data); // Pass the original data to calculateCounts
    } catch (error) {
      console.error("Error fetching registrations:", error); // Debugging statement
    }
  };

  const getPublicForms = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/public-forms`);
      setPublicForms(response.data);
      console.log("Fetched public forms:", response.data); // Debugging statement
    } catch (error) {
      console.error("Error fetching public forms:", error); // Debugging statement
    }
  };

  const calculateCounts = (data) => {
    const used = data.filter(item => item.status === "used").length;
    const unused = data.filter(item => item.status === "unused").length;
    setUsedCount(used);
    setUnusedCount(unused);
  };

  // Pagination: Calculate data for the current page
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const combinedData = [...registrations, ...publicForms];
  const currentData = combinedData.slice(startIndex, endIndex);
  const totalPages = Math.ceil(combinedData.length / rowsPerPage);

  // Pagination: Handle next page
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  // Pagination: Handle previous page
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const handlePageInputChange = (e) => {
    setPageInput(e.target.value);
  };

  const handlePageSearch = () => {
    const pageNumber = parseInt(pageInput, 10);
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <div>
      <h1 className="title mt-5">List of Registrations and Public Forms</h1>

      <div className="data-counts">
        <p>Used Data: {usedCount}</p>
        <p>Unused Data: {unusedCount}</p>
      </div>
      <div>
        <table className="table is-striped is-fullwidth">
          <thead>
            <tr>
              <th>No</th>
              <th>Name</th>
              <th>Father's Name</th>
              <th>Address</th>
              <th>District</th>
              <th>Mobile Numbers</th>
              {/* <th>Status</th> */}
            </tr>
          </thead>
          <tbody>
            {currentData.map((item, index) => (
              <tr key={item.id}>
                <td>{startIndex + index + 1}</td>
                <td>{item.name || "N/A"}</td>
                <td>{item.fatherName || item.father_name || "N/A"}</td>
                <td>{item.address || "N/A"}</td>
                <td>{item.district || "N/A"}</td>
                <td>
                  {[item.phone1, item.phone2, item.phone3, item.phone4]
                    .filter(Boolean)
                    .join(", ") || "N/A"}
                </td>
                {/* <td>{item.status || "N/A"}</td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div className="pagination-buttons mb-5" style={{ marginTop: "10px" }}>
        <button
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
          className="button is-small is-primary"
        >
          Previous
        </button>
        <span style={{ margin: "0 10px" }}>Page {currentPage} of {totalPages}</span>
        <button
          onClick={handleNextPage}
          disabled={currentPage >= totalPages}
          className="button is-small is-primary"
        >
          Next
        </button>
        <input
          type="number"
          value={pageInput}
          onChange={handlePageInputChange}
          placeholder="Page number"
          className="input is-small"
          style={{ marginLeft: "20px", width: "120px" }}
        />
        <button
          onClick={handlePageSearch}
          className="button is-small is-primary"
          style={{ marginLeft: "5px" }}
        >
          Go
        </button>
      </div>
    </div>
  );
};

export default RegistrationList;
